import { emailError, passwordError, passwordLengthError } from '../../constants/errors';
import { email as emailReg } from '../../constants/regExp';
var validation = function (values) {
    var errors = {};
    if (!values.email || !emailReg.test(values.email)) {
        errors.email = emailError;
    }
    if (!values.password) {
        errors.password = passwordError;
    }
    else if (values.password.length < 8) {
        errors.password = passwordLengthError;
    }
    return errors;
};
export default validation;
//# sourceMappingURL=login.js.map